import { useQuery } from '@tanstack/react-query';
import { getApiClient } from '@signalvote/api-client';
import { queryKeys } from '@/lib/queryKeys';

/**
 * This Express link as the person opening it sees it: who sent it and what a text costs, read with no
 * session for the screens before the account exists. Kept as long as the server keeps its own read of
 * the Stripe Prices, so the steps before sign-up share one answer.
 */
export function useExpressLink(code: string) {
  return useQuery({
    queryKey: queryKeys.expressLink.detail(code),
    queryFn: () => getApiClient().expressLink.get(code),
    staleTime: 5 * 60_000,
    retry: false,
  });
}

/**
 * The campaigns the signed-in person can send from through this Express link (owner or full admin), newest
 * first, each with its unpaid Text send.
 */
export function useExpressLinkCampaigns(code: string, userId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.expressLink.campaigns(code, userId),
    queryFn: () => getApiClient().expressLink.campaigns(code),
    enabled: userId !== undefined,
    retry: false,
  });
}

/** The Consultant whose Express link made this campaign, as the send steps name who invited it. It never changes. */
export function useExpressConsultant(campaignId: string | null) {
  return useQuery({
    queryKey: queryKeys.tenantCampaigns.expressConsultant(campaignId ?? ''),
    queryFn: () => getApiClient().expressConsultant.get(campaignId!),
    enabled: campaignId !== null,
    staleTime: Infinity,
  });
}
